<div class="heroText"><slot></slot></div>